import './../../styles/AddHotspotsOnMap.scss';
import { HiMapPin } from "react-icons/hi2";
import { useEffect, useState } from 'react';
import { Select, MenuItem, Button, FormControl, InputLabel, Tooltip } from '@mui/material';
import { ASSETS_PATH } from '../../constants';
import { uploadAsset } from '../../utilities/assetUtils';
import CircularWithValueLabel from '../../components/CircularWithValueLabel';
import Swal from 'sweetalert2';


let selectedHotspot = null;
let gHotspots = [];
let mapHeight = 0;

const AddHotspotsOnMap = ({ onCloseMapPop, mapData, hotspot, spaces, locations, onUpdateAndClosePop }) => {

    const [activeHotspot, setActiveHotspot] = useState(hotspot);
    const [progress, setProgress] = useState(0);
    const [uploading, setUploading] = useState(false)


    const onHotspotDown = (e) => {        

        selectedHotspot = e.currentTarget;

        //selectedHotspot.style.fill = 'red';
        document.addEventListener('mousemove', onHotspotMove);


    }


    const onHotspotMove = (e) => {
        console.log('mousemove')
        const left = parseInt(selectedHotspot.style.left);
        const top = parseInt(selectedHotspot.style.top);        

        let newLeft = e.movementX + left;

        newLeft = newLeft < 0 ? 0 : newLeft;
        newLeft = newLeft > 800 ? 800 : newLeft;

        let newTop = e.movementY + top;

        newTop = newTop < 0 ? 0 : newTop;
        newTop = newTop > mapHeight ? mapHeight : newTop;

        selectedHotspot.style.left = newLeft + 'px';
        selectedHotspot.style.top = newTop + 'px';



        if (selectedHotspot.getAttribute('type') == 'start') {
            console.log("in start")
            setActiveHotspot(prev => {
                return { ...prev, x: newLeft, y: newTop }
            })
        } else {
            console.log("in target")
            setActiveHotspot(prev => {
                return { ...prev, dx: newLeft, dy: newTop }
            })
        }


    }




    const onChangeStartingPoint = (e, item) => {

        const id = parseInt(e.target.value.split("-")[1]);
        const type = e.target.value.split("-")[0];

        setActiveHotspot(prev => {
            return { ...prev, space_id: type == 'space' ? id : 0, location_id: type == 'location' ? id : 0, type }
        });


    }

    const onChangeDestinationPoint = (e, item) => {

        const id = parseInt(e.target.value.split("-")[1]);
        const type = e.target.value.split("-")[0];

        setActiveHotspot(prev => {
            return {
                ...prev,
                d_space_id: type == 'space' ? id : 0,
                d_location_id: type == 'location' ? id : 0,
                d_type: type
            }
        });


    }


    const onChangeRoute = (e) => {
        uploadAsset(e, (fileName) => {
            setActiveHotspot(h => {
                return { ...h, route: fileName }
            })
        }, setUploading, setProgress);
    }


    const onRemoveRoute = () => {
        setActiveHotspot(prev => {
            return {...prev, route:''}
        })
    }

    const onUpdateAndClose = () => {

        if (
            (activeHotspot.space_id === 0 && activeHotspot.location_id === 0) ||
            (activeHotspot.d_space_id === 0 && activeHotspot.d_location_id === 0) ||
            !activeHotspot.route ||
            !activeHotspot.x || !activeHotspot.y || !activeHotspot.dx || !activeHotspot.dy
        ) {
            Swal.fire({
                icon: 'error',
                title: 'Incomplete Information',
                text: 'Please select a starting point, a destination point, upload a route image, and place both pins on the map.',
            });
            return;
        }

        if (activeHotspot.space_id !== 0 && activeHotspot.location_id !== 0) {
            Swal.fire({
                icon: 'error',
                title: 'Invalid Selection',
                text: 'Please select either a space or a location for the starting point, not both.',
            });
            return;
        }
        onUpdateAndClosePop(activeHotspot);
    }

    useEffect(() => {

        setMapHeight();

        setTimeout(() => {
            setMapHeight();
        }, 1000);

        setTimeout(() => {
            setMapHeight();
        }, 2000);

        setTimeout(() => {
            setMapHeight();
        }, 10000);

        document.addEventListener('mouseup', () => {
            document.removeEventListener('mousemove', onHotspotMove);
            selectedHotspot = null;
        });

    });

    const setMapHeight = () => {
        if(document.getElementById('map')){
            mapHeight = document.getElementById('map').offsetHeight;
            document.getElementById('hotspots-body').style.height = mapHeight + 'px';
        }
    }


    return (
        <>
            <div className="pop-map-background"></div>
            <div className='pop-map'>
                <div className='pop-header'>
                    <div className='map-name'>
                        Place Route
                    </div>
                    <div>
                        {activeHotspot &&
                            <FormControl variant="standard" sx={{ m: 1, minWidth: 220, backgroundColor: 'rgba(128, 0, 128, 0.3)' }}>
                                <InputLabel id="demo-simple-select-standard-label">Select starting point</InputLabel>
                                <Select label="Select starting point" value={activeHotspot.space_id ? `space-${activeHotspot.space_id}` : `location-${activeHotspot.location_id}`} onChange={onChangeStartingPoint}>
                                    <MenuItem value={'location-0'}>Select starting point</MenuItem>
                                    {spaces.map((s, index) => <MenuItem key={`s${index}`} value={`space-${s.space_id}`}>{s.space_name}</MenuItem>)}
                                    {locations.map((l, index) => <MenuItem key={`l${index}`} value={`location-${l.location_id}`}>{l.location_name}</MenuItem>)}

                                </Select>
                            </FormControl>
                        }

                        {activeHotspot &&
                            <FormControl variant="standard" sx={{ m: 1, minWidth: 220, backgroundColor: 'rgba(255, 0, 0, 0.3)' }}
                            >
                                <InputLabel id="demo-simple-select-standard-label">Select destination point</InputLabel>
                                <Select label="Select destination point" value={activeHotspot.d_space_id ? `space-${activeHotspot.d_space_id}` : `location-${activeHotspot.d_location_id}`} onChange={onChangeDestinationPoint}>
                                    <MenuItem value={'location-0'}>Select destination point</MenuItem >
                                    {spaces.map((s, index) => <MenuItem key={`s${index}`} value={`space-${s.space_id}`}>{s.space_name}</MenuItem>)}
                                    {locations.map((l, index) => <MenuItem key={`l${index}`} value={`location-${l.location_id}`}>{l.location_name}</MenuItem>)}
                                </Select>
                            </FormControl>
                        }
                    </div>
                </div>
                <div className='pop-body'>
                    <div className='hotspots-body' id='hotspots-body'>
                        <img src={`${ASSETS_PATH}/${mapData.map_image_2d}`} id="map" />
                        {activeHotspot.route && <img src={`${ASSETS_PATH}/${activeHotspot.route}`} id="route" />}
                        <HiMapPin
                            className='hotspot'
                            type="start"
                            onMouseDown={(e) => { onHotspotDown(e) }}
                            style={{
                                top: activeHotspot.y + 'px',
                                left: activeHotspot.x + 'px',
                                fill: 'purple'
                            }}
                        />
                        <HiMapPin
                            className='hotspot'
                            type="target"
                            onMouseDown={(e) => { onHotspotDown(e) }}
                            style={{
                                top: activeHotspot.dy + 'px',
                                left: activeHotspot.dx + 'px',
                                fill: 'red'
                            }}
                        />

                    </div>
                </div>
                <div className='pop-footer'>
                    {!activeHotspot.route && <Button
                        
                        component="label"
                        style={{ marginRight: "10px" }}
                    >
                        *Upload Route
                        <input
                            type="file"
                            hidden
                            onChange={onChangeRoute}
                        />
                    </Button>}

                    {activeHotspot.route && <Button
                        
                        style={{ marginRight: "10px" }}
                        onClick={onRemoveRoute}
                    >
                        Remove Route
                        
                    </Button>}
                    <Button onClick={onUpdateAndClose}>Update and Close</Button>
                    <Button variant='contained' onClick={onCloseMapPop}>Close</Button>
                </div>
            </div>
            {uploading && <CircularWithValueLabel progress={progress} />}
        </>
    )
}

export default AddHotspotsOnMap;